module.exports = __webpack_public_path__ + "img/login_bg.3e32bc16.png";